module.exports = __webpack_public_path__ + "img/chart-primary.b706cadb.svg";